import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 51 50"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "25.333",
      cy: "25",
      r: "24.456",
      fill: "#FCFEFF",
      stroke: "#83B9FF",
      "stroke-dasharray": "4.35 4.35",
      "stroke-width": "1.087"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#4893F4",
      d: "M32.633 20.92v5.15c0 3.08-1.76 4.4-4.4 4.4h-8.79c-.45 0-.88-.04-1.28-.13-.25-.04-.49-.11-.71-.19-1.5-.56-2.41-1.86-2.41-4.08v-5.15c0-3.08 1.76-4.4 4.4-4.4h8.79c2.24 0 3.85.95 4.28 3.12.07.4.12.81.12 1.28",
      opacity: ".4"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#4893F4",
      d: "M35.633 23.92v5.15c0 3.08-1.76 4.4-4.4 4.4h-8.79c-.74 0-1.41-.1-1.99-.32-1.19-.44-2-1.35-2.29-2.81.4.09.83.13 1.28.13h8.79c2.64 0 4.4-1.32 4.4-4.4v-5.15c0-.47-.04-.89-.12-1.28 1.9.4 3.12 1.74 3.12 4.28"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#4893F4",
      d: "M23.833 26.14a2.64 2.64 0 1 0 0-5.28 2.64 2.64 0 0 0 0 5.28m-5.72-4.89c-.41 0-.75.34-.75.75v3c0 .41.34.75.75.75s.75-.34.75-.75v-3c0-.41-.33-.75-.75-.75m11.43 0c-.41 0-.75.34-.75.75v3c0 .41.34.75.75.75s.75-.34.75-.75v-3c0-.41-.33-.75-.75-.75"
    }, null, -1)
  ]))]))
}
export default { render: render }